export default __webpack_public_path__ + "static/media/faq.88b4f513.png";